import { supabase } from '../../core/config/supabase';
import { User } from '../models';
import { logger } from '@/src/core/utils';

interface SearchUserEntity {
  id: string;
  email: string;
  name?: string;
  avatar_url?: string;
  created_at: string;
}

export class SearchUsersUseCase {
  async execute(query: string, limit: number = 20, offset: number = 0): Promise<User[]> {
    logger.debug('SearchUsers', 'Searching users', { query, limit, offset });

    // Minimum 2 characters required
    if (!query || query.trim().length < 2) {
      return [];
    }

    try {
      // Use RPC function to search users
      const { data, error } = await supabase.rpc('search_users', {
        search_query: query.trim(),
        limit_count: limit,
        offset_count: offset,
      });

      if (error) {
        logger.error('SearchUsers', 'Failed to search users', { error });
        throw new Error(error.message);
      }

      logger.debug('SearchUsers', 'Search results', { count: data?.length || 0 });

      // Map to User model
      return (data as SearchUserEntity[]).map(user => ({
        id: user.id,
        email: user.email || '',
        name: user.name,
        avatarUrl: user.avatar_url,
        createdAt: new Date(user.created_at),
      }));
    } catch (error) {
      logger.error('SearchUsers', 'Failed to search users', { error });
      throw error;
    }
  }
}
